export default __webpack_public_path__ + "static/media/katja.ef51cb0b.jpg";